type Translate = (key: string, options: { defaultValue: string }) => string;
type Details = Record<string, unknown> | undefined;

/** A WeTransfer import's `CODE: English text` reason in the reader's language; an unknown code keeps the text after the colon. */
export const translateWeTransferReason = (reason: string, t: Translate): string => {
  const colon = reason.indexOf(':');
  if (colon < 0) return reason;

  return t(`artwork_drive.wetransfer_reasons.${reason.slice(0, colon)}`, {
    defaultValue: reason.slice(colon + 1).trim(),
  });
};

/** What a notification of [type] adds to its text's values: a failed WeTransfer import's reason, translated. */
export const weTransferNotificationValues = (
  type: string,
  details: Details,
  t: Translate,
): { reason?: string } =>
  type === 'WETRANSFER_IMPORT_FAILED'
    ? { reason: translateWeTransferReason(String(details?.reason ?? ''), t) }
    : {};

/** The variant a notification's body is read in: a service task's, a media plan's, or the plain one. */
export const notificationBodyContext = (
  details: Details,
  extraDetails?: Details,
): 'serviceType' | 'plan' | undefined => {
  if (extraDetails?.serviceType) return 'serviceType';

  return details?.planId ? 'plan' : undefined;
};
